import { useState, useEffect } from 'react';
import { Route, Routes, Navigate, BrowserRouter, useNavigate } from 'react-router-dom';
import { smallWindowThreshold } from './config';

import Root from "./sections/Root";
import Home from "./sections/Home";
import Legal from './sections/Legal';
import Blank from './sections/Blank';
import Section from './sections/Section';
import About from './sections/About';
import './ClientApp.css';


function KeepInSync ({section, sectionLookup, clientNavTracker}) {
    // Keeps client navigation in sync with update app
    const [currentTracker, setCurrentTracker] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
      if (currentTracker !== clientNavTracker){
        //only navigate if change originates from updateApp and valid section
        if (section in sectionLookup){
          navigate(section);
        }
        setCurrentTracker(clientNavTracker);
      }
    }, [navigate, section, setCurrentTracker,currentTracker, clientNavTracker, sectionLookup])
}

export default function ClientApp({content, section, clientNavTracker, windowSize}) {
  const [topNavWidth, setTopNavWidth] = useState(null);
  const [topNavHeight, setTopNavHeight] = useState(null);
  const smallWindow = (content && content.menuPosition === 'Left' && windowSize.width < smallWindowThreshold) || (topNavWidth && topNavHeight && topNavHeight > 60 &&  !(windowSize.width > topNavWidth * 1.1));

  // Populate navigation routes based on the sections defined in content
  let sectionLookupInitial = {   
    "about": <About key='about' content={content} smallWindow={smallWindow} windowSize={windowSize}/>,
    "legal": <Legal content={content} smallWindow={smallWindow}/>,
    "blank": <Blank content={content} smallWindow={smallWindow}/>
  }

  if (content) {
    content.sections.forEach((value) => {
      if (value !== 'about') {
        sectionLookupInitial[value] = <Section key={value} content={content} smallWindow={smallWindow} section={value} windowWidth={windowSize.width} />;
      }
    })
  }
   
  const sectionLookup = {...sectionLookupInitial, "home": <Home content={content} windowWidth={windowSize.width} sectionLookup={sectionLookupInitial} smallWindow={smallWindow}/>}

  if (!content) {
    return <div>Loading...</div>;
  } else {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Root content={content} smallWindow={smallWindow} windowSize={windowSize} setTopNavWidth={setTopNavWidth} setTopNavHeight={setTopNavHeight}/>}>
            <Route index element={sectionLookup['home']} />
            {Object.keys(sectionLookup).map((section) => {
              return <Route key={section} path={section} element={sectionLookup[section] } />
            })}
          </Route>
          <Route path="*" element={<Navigate to='/' replace />}/>
        </Routes>
        <KeepInSync section={section} sectionLookup={sectionLookup} clientNavTracker={clientNavTracker}/>
      </BrowserRouter>

      );
    }
}
